import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { MajorMinorFontScheme } from './major-minor-font-scheme';
/**
 * @private
 */
export class FontScheme {
    get fontSchemeName() {
        return this.schemeName;
    }
    set fontSchemeName(value) {
        this.schemeName = value;
    }
    get majorFontScheme() {
        return this.majFontScheme;
    }
    set majorFontScheme(value) {
        this.majFontScheme = value;
    }
    get minorFontScheme() {
        return this.minFontScheme;
    }
    set minorFontScheme(value) {
        this.minFontScheme = value;
    }
    constructor(node) {
        this.majFontScheme = new MajorMinorFontScheme();
        this.minFontScheme = new MajorMinorFontScheme();
    }
    copyFormat(fontScheme) {
        if (!isNullOrUndefined(fontScheme)) {
            this.schemeName = fontScheme.schemeName;
            this.majFontScheme.copyFormat(fontScheme.majFontScheme);
            this.minFontScheme.copyFormat(fontScheme.minFontScheme);
        }
    }
    destroy() {
        this.schemeName = undefined;
        this.majFontScheme = undefined;
        this.minFontScheme = undefined;
    }
}
/**
 * @private
 */
export class FontSchemeStruct {
    get name() {
        return this.fontName;
    }
    set name(value) {
        this.fontName = value;
    }
    get typeface() {
        return this.fontTypeface;
    }
    set typeface(value) {
        this.fontTypeface = value;
    }
    get panose() {
        return this.pnose;
    }
    set panose(value) {
        this.pnose = value;
    }
    copyFormat(fontSchemeStructure) {
        if (!isNullOrUndefined(fontSchemeStructure)) {
            this.fontName = fontSchemeStructure.fontName;
            this.fontTypeface = fontSchemeStructure.fontTypeface;
            this.pnose = fontSchemeStructure.panose;
        }
    }
    destroy() {
        this.fontName = undefined;
        this.fontTypeface = undefined;
        this.pnose = undefined;
    }
}
